import { Component, OnInit, TemplateRef  } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import * as moment from 'moment';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { LoginService } from 'src/app/modules/retailer/services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loginForm: FormGroup;
  public buttonLoader: any = false;

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _loginService: LoginService
  ) {}

  ngOnInit(): void {
    // Set login form
    this.loginForm = new FormGroup({
      username: new FormControl(null, [Validators.required, Validators.minLength(3)]),
      password: new FormControl(null, [Validators.required, Validators.minLength(3)]),
    });
  }

  // Login submit
  async onLogin() {
    if (this.loginForm.value.username && this.loginForm.value.password) {
      let userLoginBody = {
        mode: 'RETAILER',
        username: this.loginForm.value.username,
        password: this.loginForm.value.password
      };

      this.buttonLoader = true;

      // Check username & password
      this._loginService.userLogin(userLoginBody).subscribe(async userLoginResponse => {
        if (userLoginResponse.status === true) { // Success
          // Get retailer list
          let getRetailersBody = {
            provider_type: userLoginResponse.user_details.provider_type,
	          provider_id: userLoginResponse.user_details.provider_id
          };

          this._loginService.getRetailers(userLoginResponse.token, getRetailersBody).subscribe(async getRetailersResponse => {
            this.buttonLoader = false;

            if (getRetailersResponse.status === true) { // Success
              // Add login data to local storage
              let responseSetStorageDataC_LOGIN = await this._utilService.setStorageData('R_LOGIN', userLoginResponse);
              let responseSetStorageDataC_RETAILERS = await this._utilService.setStorageData('R_RETAILERS', getRetailersResponse.retailers);

              if (responseSetStorageDataC_LOGIN && responseSetStorageDataC_RETAILERS) {
                this._router.navigate(['/retailer/create-coupon']); // Go to Retailer Create Coupon
              } else {
                this._utilService.showToast('Error while saving login data', '', 'error', {});
              }
            } else {
              this._utilService.showToast(getRetailersResponse.message, '', 'error', {});
            }
          }, error2 => { // Error from getRetailers
            this.buttonLoader = false;
          });
        } else {
          this.buttonLoader = false;
          this._utilService.showToast(userLoginResponse.message, '', 'error', {});
        }
      }, error1 => { // Error from userLogin
        this.buttonLoader = false;
        this._utilService.showToast(environment.apiErrorMessage, '', 'error', {});
      });
    } else {
      this._utilService.showToast('Please enter username and password', '', 'warning', {});
    }
  }


}
